// extracted by mini-css-extract-plugin
export default {"wrapper":"radio-button-group_wrapper","item":"radio-button-group_item","selected":"radio-button-group_selected","itemLabel":"radio-button-group_itemLabel"};